import React from 'react';
import PrivateRoute from '../../components/common/PrivateRoute';
import {Switch, Route} from 'react-router-dom';
import PageError from "../../components/layout/PageError";
import Dashboard from "../../pages/authorized/Dashboard";
import Access from "../../pages/authorized/Access";
import Crop from "../../pages/authorized/Crop";
import Company from "../../pages/authorized/Company";
import User from "../../pages/authorized/User";
import UserDetail from "../../pages/authorized/UserDetail";
import CompanyDetail from "../../pages/authorized/CompanyDetail";
import CompanyVerification from "../../pages/authorized/CompanyVerification";
import Scheme from "../../pages/authorized/Scheme";
import SchemeApplication from "../../pages/authorized/SchemeApplication";
import InputDelivery from "../../pages/authorized/InputDelivery";
import InputDeliveryDetail from "../../pages/authorized/InputDeliveryDetail";
import PreSeasonContract from "../../pages/authorized/PreSeasonContract";
import PreSeasonContractDetail from "../../pages/authorized/PreSeasonContractDetail";
import Farm from "../../pages/authorized/Farm";
import FarmDetail from "../../pages/authorized/FarmDetail";
import FarmInspectionDetail from "../../pages/authorized/FarmInspectionDetail";
import TradeOffer from "../../pages/authorized/TradeOffer";
import TradeOfferDetail from "../../pages/authorized/TradeOfferDetail";
import SellRequest from "../../pages/authorized/SellRequest";
import SellRequestDetail from "../../pages/authorized/SellRequestDetail";
import Activity from "../../pages/authorized/Activity";
import Product from "../../pages/authorized/Product";
import ProductDetail from "../../pages/authorized/ProductDetail";
import Support from "../../pages/authorized/Support";

const Private = () => {
    return (
        <div>
            <Switch>
                <PrivateRoute exact path="/dashboard" component={Dashboard} />
                <PrivateRoute exact path="/company" component={Company} />
                <PrivateRoute exact path="/company/:id" component={CompanyDetail} />
                <PrivateRoute exact path="/company/:id/verification" component={CompanyVerification} />
                <PrivateRoute exact path="/user" component={User} />
                <PrivateRoute exact path="/user/:id" component={UserDetail} />
                <PrivateRoute exact path="/crop" component={Crop} />
                <PrivateRoute exact path="/access" component={Access} />
                <PrivateRoute exact path="/scheme" component={Scheme} />
                <PrivateRoute exact path="/scheme_application" component={SchemeApplication} />
                <PrivateRoute exact path="/input_delivery" component={InputDelivery} />
                <PrivateRoute exact path="/input_delivery/:id" component={InputDeliveryDetail} />
                <PrivateRoute exact path="/preseason_contract" component={PreSeasonContract} />
                <PrivateRoute exact path="/preseason_contract/:id" component={PreSeasonContractDetail} />
                <PrivateRoute exact path="/farm" component={Farm} />
                <PrivateRoute exact path="/farm/:id" component={FarmDetail} />
                <PrivateRoute exact path="/farm_inspection/:id" component={FarmInspectionDetail} />
                <PrivateRoute exact path="/trade_offer" component={TradeOffer} />
                <PrivateRoute exact path="/trade_offer/:id" component={TradeOfferDetail} />
                <PrivateRoute exact path="/sell_request" component={SellRequest} />
                <PrivateRoute exact path="/sell_request/:id" component={SellRequestDetail} />
                <PrivateRoute exact path="/product" component={Product} />
                <PrivateRoute exact path="/product/:id" component={ProductDetail} />
                <PrivateRoute exact path="/activity" component={Activity} />
                <PrivateRoute exact path="/support" component={Support} />
                <PrivateRoute exact path="/error" component={PageError} />
                <Route component={PageError} />
            </Switch>
        </div>
    )
};

export default Private;
